export class SetBoxesStatusDto {
    public orderId: number;
    public boxTexts: string[];
    public deliveryTaskId: string;
}
